import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Dropzone from 'react-dropzone';
import { getClassName } from '../../utils/forms';
import { catchClientSideError } from '../../actions/common';
import { toIdString } from '../../utils/common';

export class UploadField extends React.Component {
  static propTypes = {
    acceptedFileType: PropTypes.string.isRequired,
    catchClientSideErrorAction: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  };

  onDrop = (isLayout, input) => filesToUpload => {
    const { acceptedFileType, catchClientSideErrorAction } = this.props;
    const fileType =
      filesToUpload[0] !== undefined && filesToUpload[0].name.length >= 4
        ? filesToUpload[0].name.substring(filesToUpload[0].name.length - 4).toLowerCase()
        : '';

    if (fileType === acceptedFileType) {
      input.onChange(filesToUpload);
    } else {
      const message = `Incorrect file type. Please choose a "${acceptedFileType}" file type.`;
      const error = new Error(message);
      catchClientSideErrorAction(error);
    }
  };

  renderDropZone = ({ input, name, label, meta: { touched, error } }) => {
    const files = input.value;
    return (
      <div className={getClassName(touched, error)}>
        <label htmlFor={`dz-field-${toIdString(label)}`} className="form-control-label">
          {label}: {touched && error && <span>| {error}</span>}
        </label>
        <Dropzone
          id={`dz-field-${toIdString(label)}`}
          onDrop={this.onDrop(true, input)}
          multiple={false}
          name={name}
          className="form-control"
        >
          <div>drop a file here, or click to select file to upload.</div>
        </Dropzone>
        {files && Array.isArray(files) ? (
          <div className="form-group">
            <label htmlFor={`upload-field-${toIdString(label)}`} className="form-control-label">
              {label} to Upload:
            </label>
            {files.map(file => (
              <span id={`upload-field-${toIdString(label)}`} key={file.name}>
                {file.name}
              </span>
            ))}
          </div>
        ) : null}
      </div>
    );
  };

  render() {
    const { label, name } = this.props;

    return <Field name={name} type="file" component={this.renderDropZone} label={label} />;
  }
}

export default connect(null, {
  catchClientSideErrorAction: catchClientSideError,
})(UploadField);
